import { Config } from '../config';
export function getConfig() {
    const res = new Config();
    res.anzeigetyp = 'Segler';
    res.titel = 'Gärtnerei Blu-Blumen GbR';
    res.begruessung = 'Webshop für Fachhandel & Wiederverkäufer Bioland Kräuter & Gemüsepflanzen';
    res.bestellnummer = false;
    res.zeigeDetailsInDetailfenster = false;
    res.inputBorder = 'black 1px solid';
    return res;
}
